import React, { useState, useEffect,useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useResizeDetector } from 'react-resize-detector';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import './style.css';
import {
  addNewBooking,
  editBooking,
  loadBooking,
  resetBookingFlag,
  clearBooking,
  clearSpecialBookingData,
  resetCharges,
  editDiscount,
  fetchDiscountByBooking,
  resetDiscountBooking,
} from '../../../../general_redux/calendar/actions';
import {
  addGuests,
  loadGuests,
  getGuestByBooking,
  clearGuest
} from '../../../../general_redux/guest/actions';
import { loadRental, loadGroup, loadProperty } from '../../../../general_redux/rentals/actions';
import { loadApplicationData, resetUser } from '../../../../general_redux/user/actions';
import {
    rateList,
    getFeeList,
    fetchTax,
    getWeeklyFixedRate,
    getWeeklyFixedFee,
    getWeeklyFixedTax,
    getMonthlyFixedRate,
    getMonthlyFixedFee,
    getMonthlyFixedTax,
} from '../../../../general_redux/rates/actions';
import { getInvoices } from '../../../../general_redux/invoice/actions';
import { getNotificationList } from '../../../../general_redux/notifications/actions';
import { LoadSettings } from '../../../../general_redux/general settings/actions';
import SlideSelect from '../../../../components/Slide_select/Slide_select';
import CustomTimeLine from '../../../../components/CustomTimeLine';
import Loading from '../../../../components/loading';
import SelectButton from '../../../../components/Selectbutton/SelectButton';
import NewBooking from './components/NewBooking/AddNewBooking';
import BlockDate from './components/BlockDate/BlockDate';
import ViewBooking from './components/ViewBooking/ViewBooking';
import WelcomeModal from './components/WelcomeScreen/Welcome';
import ViewBlockDate from './components/ViewBlockDate/ViewBlockDate';
import EditBooking from './components/EditBooking/EditBooking';
import AddSpecialBooking from "./components/AddSpecialBooking/AddSpecialBooking";
import AddGuest from "./components/AddSpecialBooking/AddGuest";
import EmptyNightPopover from './components/EmptyNightPopover/EmptyNightPopover';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import styles from './calendar.module.css';
import { customSort } from '../../../../common/functions/utils';


const Calendar = (props) => {
  
  const rentalList = useSelector(({ rentals }) => rentals && rentals.rentals).map((row) => ({
    id: row.id,
    title: row.name,
    groupId: row.groupId,
    propertyId: row.propertyId,
    parentRentalId: row.parentRentalId,
  }));

  const { width, ref } = useResizeDetector();
  const appDataLoaded = useSelector(({ user }) => user && user.appDataLoaded);
  const allBookings = useSelector(({ calendar }) => calendar && calendar.allBooking);
  const itemStatus = useSelector(({ calendar }) => calendar && calendar.actionForBooking);
  const actionForRental = useSelector(({ rentals }) => rentals && rentals.actionForRental);
  const actionForGuest = useSelector(({ guests }) => guests && guests.actionForLoad);
  const actionForRate = useSelector(({ rates }) => rates && rates.actionForRateList);
  const guestPopUpStatus = useSelector(({ guests }) => guests && guests.actionForGuestLoad);
  const delStatus = useSelector(({ calendar }) => calendar && calendar.actionDeleteBooking);
  const actionDeleteBlockDate = useSelector(({ calendar }) => calendar && calendar.actionDeleteBlockDate);
  const actionForAddBooking = useSelector(({ calendar }) => calendar && calendar.actionForAddBooking);
  const actionForEditBooking = useSelector(({calendar})=> calendar && calendar.actionEditBooking);
  const dispatch = useDispatch();

  //calendar props
  const now = new Date().getUTCFullYear();
  const myLast = now + 3;
  const years = Array(myLast - (myLast - 7))
    .fill('')
    .map((v, idx) => myLast - idx)
    .reverse();
  
  const Months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const childRef = useRef();

  const d = new Date();
  const [currentSelectMonth, setCurrentSelectMonth] = useState(d.getMonth());
  const [currentSelectYear, setCurrentSelectYear] = useState(years.length - 4);
  const [viewBooking, setViewBooking] = useState(false);
  const [viewBlockDate, setViewBlockDate] = useState(false);
  const [addBooking, setAddBooking] = useState(false);
  const [addSpecialBooking, setAddSpecialBooking] = useState(false);
  const [addGuest, setAddGuest] = useState(false);
  const [blockDate, setBlockDate] = useState(false);
  const isNewUser = useSelector(({user})=>user && user.user && user.user.isNewUser);
  const [welcomeModal, setWelcomeModal] = useState();
  const [viewData, setViewData] = useState(null);
  const [bookingData, setBookingData] = useState(null);
  const [guestId, setGuestId] = useState(null);
  const [bookerId, setBookerId] = useState(null);
  const [guestData, setGuestData] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [viewEditBooking, setViewEditBooking] = useState(false);
  const [emptyNight, setEmptyNight] = useState(null);
  const [emptyNightAnchorEl, setEmptyNightAnchorEl] = useState(null);
  const [distanceToScreenMargin, setDistanceToScreenMargin] = useState(0);
  
  const rentalHierarchy = customSort(rentalList, 'asc', 'title');

  const handleSaveBooking = (data) => {

    const {
      payloadBooking,
      payloadGuest,
      payloadBooker,
    } = data;

    setAddBooking(false);
    setBlockDate(false);
    setGuestId(null);
    setBookerId(null);
    dispatch(resetBookingFlag());
    setBookingData(payloadBooking.data);

    // are the guest and the booker the same person?:
    const areTheSamePerson = payloadBooking.guestMadeReservation;

    if (payloadGuest.isNew) {
        dispatch(addGuests(payloadGuest.data)).then((res) => {
            setGuestId(res.data.guest.id);
            if (areTheSamePerson) setBookerId(res.data.guest.id);
        });
    } else {
        setGuestId(payloadGuest.data.id)
        if (areTheSamePerson) setBookerId(payloadGuest.data.id);
    }

    if (!areTheSamePerson) {
        if (payloadBooker.isNew) {
            dispatch(addGuests(payloadBooker.data)).then((res) => {
              setBookerId(res.data.guest.id);
            });
        } else {
            setBookerId(payloadBooker.data.id);
        }
    }

  };
  
  const selectBooking = (id) => {
    const viewItem = allBookings.filter((item) => item.id === id)[0];
    if (["booking", "weekly", "monthly", "channelBooking"].includes(viewItem.type)) {
      if (viewItem && viewItem.length !== 0) {
        dispatch(getGuestByBooking(viewItem.id));
        setViewData(viewItem);
        setViewBooking(true);
      }
    }
    if (["blockdates", "blockNightsBefore", "blockNightsAfter",].includes(viewItem.type)) {
      setViewData(viewItem);
      setViewBlockDate(true);
    }
  };

  const addBookingFromPopover = (bookingType) => {
    if (bookingType === 'booking') {
      setAddBooking(true);
    } else if (bookingType === 'weekly') {
      setAddSpecialBooking(true);
    } else if (bookingType === 'blockdates') {
      setBlockDate(true);
    };
  };

  const emptyNightOpenPopover = (e) => {
    setEmptyNightAnchorEl(emptyNightAnchorEl ? null : e.currentTarget);
  };

  const emptyNightClosePopover = () => {
    setEmptyNightAnchorEl(null);
  };

  const selectEmptyNight = (rentalId, time, e, distance) => {
    const arrive = new Date(Number(time))
    setEmptyNight({
      rentalId: rentalId,
      arrive: arrive,
    });
    setDistanceToScreenMargin(distance);
    emptyNightOpenPopover(e);
  };

  const onCloseWelcome = () => {
    dispatch(resetUser({
      isNewUser:false,
    }));
    setWelcomeModal(false);
  };

  useEffect(() => {
    if (appDataLoaded) {
        return;
    };

    dispatch(loadRental());
    dispatch(loadGroup());
    dispatch(loadProperty());
    dispatch(getFeeList());
    dispatch(fetchTax());
    dispatch(getWeeklyFixedRate());
    dispatch(getWeeklyFixedFee());
    dispatch(getWeeklyFixedTax());
    dispatch(getMonthlyFixedRate());
    dispatch(getMonthlyFixedFee());
    dispatch(getMonthlyFixedTax());
    dispatch(LoadSettings());
    dispatch(getInvoices());

    dispatch(loadApplicationData({ isLoaded: true }));

  }, [])

  useEffect(() => {
    dispatch(loadGuests());
    dispatch(rateList());
    dispatch(loadBooking());
    dispatch(getNotificationList());
    dispatch(resetCharges());
    dispatch(resetDiscountBooking());
    dispatch(clearSpecialBookingData());
  }, [])

  useEffect(()=>{
    if(isNewUser){
      setWelcomeModal(isNewUser);
    }
  },[isNewUser])

  useEffect(() => {
    
    let cancelled = false;

    const load = async () => {
        if (guestId && bookerId) {
            bookingData.guestId = guestId;
            bookingData.bookerId = bookerId;
            const getBookingData = await dispatch(addNewBooking(bookingData));
            
            if (cancelled) return;
            const bookingList = getBookingData?.data?.booking;
            if (!Array.isArray(bookingList) || bookingList.length === 0) return;
    
            const bookingId = bookingList[0]?.id
            const getDiscountByBookingData = await dispatch(fetchDiscountByBooking(bookingId));
            const bookingDiscount = getDiscountByBookingData?.data?.items[0]
            
            // update booking price
            const totalPrice = (bookingData.baseRate + bookingData.extraGuestFee - bookingData.discountAmount + bookingData.chargeAmount + bookingData.fees + bookingData.tax)
            if (totalPrice !== bookingData.price) {
                const bookingDiscountPayload = {
                    bookingId: bookingId,
                    rentalId: bookingData.rentalId,
                    discountName: bookingData.discountName,
                    discountAmount: bookingData.discountAmount,
                    chargeName: bookingData.chargeName,
                    chargeAmount: bookingData.chargeAmount,
                    tax: bookingData.tax,
                    fees: bookingData.fees,
                    extraGuestFee: bookingData.extraGuestFee,
                    baseRate: bookingData.baseRate,
                    totalPrice: totalPrice,
                    bookingPrice: bookingData.price,
                    nights: bookingData.nights,
                    noOfAdults: bookingData.noOfAdults,
                    noOfChildren: bookingData.noOfChildren,
                };
                dispatch(editDiscount(bookingDiscountPayload, bookingDiscount?.id));
            };
    
            setGuestId(null);
            setBookerId(null);
        };
    };

    load();

    return () => {
        cancelled = true;
    };

  }, [guestId, bookerId]);

  useEffect(() => {
    if(actionForEditBooking.success){
      setBlockDate(false);
    }
  },[actionForEditBooking]);

  const handleAddBlockDate = (data) =>{
    dispatch(addNewBooking(data));
    dispatch(clearBooking());
    setBlockDate(false);
    setIsEdit(false);
  };

  const handleEditBlockDate = (data) =>{
    dispatch(editBooking(data));
    dispatch(clearBooking());
    setBlockDate(false);
    setIsEdit(false);
  };

  const handleToggleGuest = (guestData) => {
    setGuestData(guestData);
    setAddSpecialBooking(!addSpecialBooking);
    setAddGuest(!addGuest);
  };

  const closeAddSpecialBooking = () => {
    setAddSpecialBooking(false);
    setGuestData("");
    setEmptyNight(null);
    dispatch(clearSpecialBookingData());
  };
  
  return (
    <div ref={ref}>
      <Loading
        loadingStatus={
          actionForRental.loading ||
          actionForGuest.loading ||
          itemStatus.loading ||
          actionForRate.loading ||
          guestPopUpStatus.loading ||
          delStatus.loading ||
          actionDeleteBlockDate.loading ||
          actionForAddBooking.loading ||
          actionForEditBooking.loading
        }
      />
      <div className={styles.calendarHeader}>
        <WelcomeModal
            show={welcomeModal}
            onHide={onCloseWelcome}
        />
        <EmptyNightPopover
          id={"popover-empty-night"}
          open={Boolean(emptyNightAnchorEl)}
          anchorEl={emptyNightAnchorEl}
          onClose={emptyNightClosePopover}
          addBookingFromPopover={addBookingFromPopover}
          distanceToScreenMargin={distanceToScreenMargin}
          width={width}
        />
        <Modal
          show={addBooking}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          onHide={() => {
            setAddBooking(false);
            setIsEdit(false);
            setEmptyNight(null);
          }}
        >
          <NewBooking
            handleSave={(data) => handleSaveBooking(data)}
            newBookingFromEmptyNight={emptyNight}
          />
        </Modal>

        <Modal
          onHide={() => {
            setBlockDate(false);
            setEmptyNight(null);
          }}
          show={blockDate}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <BlockDate 
            handleSave={(data) => {
              handleAddBlockDate(data);
              setBlockDate(false);
            }}
            handleEdit={(data) => handleEditBlockDate(data)}
            initValues={viewData}
            isEdit={isEdit}
            blockDateFromEmptyNight={emptyNight}
          />
        </Modal>

        <Modal
          onHide={() => setViewEditBooking(false)}
          show={viewEditBooking}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"

        >
          <EditBooking
            bookingData={viewData}
            bookingId={viewData?viewData.id:null}
            setViewEditBooking={() => setViewEditBooking(false)}
          />
        </Modal>

        <Modal
            show={addSpecialBooking}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={closeAddSpecialBooking}
        >
          <AddSpecialBooking
              guestData={guestData}
              handleShowGuest={handleToggleGuest}
              onHide={closeAddSpecialBooking}
              handleSave={(data) => handleSaveBooking(data)}
              addSpecialBookingFromEmptyNight={emptyNight}
          />
        </Modal>

        <Modal
          show={addGuest}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          onHide={handleToggleGuest}
          backdrop="static"
        >
          <AddGuest handleClose={handleToggleGuest}/>
        </Modal>

        <section className={styles.button_section}>
          <div className={styles.first_button_group}>
            <SlideSelect
                list={years}
                currentSelect={currentSelectYear}
                onSelectData={(index) => childRef.current.onYearUpdate(index)} />
            <SlideSelect
              list={Months}
              currentSelect={currentSelectMonth}
              onSelectData={(index) => childRef.current.onMonthUpdate(index)}
            />
            <SelectButton text="Today" onSelection={()=>childRef.current.renderToday()}/>
          </div>

          <div className={styles.second_button_group}>
            <button
              className={`${styles.allBtn} w-25`}
              onClick={() => setAddBooking(true)}
              disabled={rentalHierarchy.length === 0}
            >
              Add Booking
            </button>
            <button
              className={`${styles.allBtn} ${styles.greyBtn} w-25`}
              onClick={() => {setAddSpecialBooking(true)}}
              disabled={rentalHierarchy.length === 0}
            >
              Add Fixed
            </button>
            <button
              className={`${styles.allBtn} ${styles.greyBtn} w-25`}
              onClick={() => {setBlockDate(true); setIsEdit(false)}}
              disabled={rentalHierarchy.length === 0}
              >
              Block Dates
            </button>
          </div>
        </section>

      </div>
      {!actionForRental.loading && !itemStatus.loading && (
        <div className={styles.upperArrow}>
          <div className="d-flex justify-content-between w-100">
            <div className={styles.arrowIcons}>
              <ArrowBackIosIcon className={styles.svgIcon} onClick={() => childRef.current.onPrevClick()} />
            </div>
            <div className={styles.arrowIcons}>
              <ArrowForwardIosIcon className={styles.svgIcon} onClick={() => childRef.current.onNextClick()} />
            </div>
          </div>
        </div>
      )}
      <CustomTimeLine
          rentalObject={rentalHierarchy}
          allBookings={allBookings}
          removeNewItem={Boolean(emptyNightAnchorEl)}
          width={width}
          itemStatus={itemStatus}
          actionForRental={actionForRental}
          ref={childRef}
          currentMonth={currentSelectMonth}
          setCurrentSelectMonth={setCurrentSelectMonth}
          setCurrentSelectYear={setCurrentSelectYear}
          clickItem={(itemId) => selectBooking(itemId)}
          selectEmptyNight={selectEmptyNight}
          viewBooking={viewBooking}
      />
      <ViewBooking
          show={viewBooking}
          onHide={() => {
            setViewBooking(false);
            dispatch(clearGuest())
          }}
          data={viewData ? viewData : []}
          onEdit={() => {
            setViewBooking(false);
            setViewEditBooking(true);
        }}
      />

      <ViewBlockDate
        show={viewBlockDate}
        onHide={() => {
          setViewBlockDate(false);
        }}
        data={viewData ? viewData : []}
        onEdit={ () => { setIsEdit(true); setBlockDate(true);}}
      />

    </div>
  );
};

export default Calendar;
